import { html } from 'lit'

export const historyIcon = html`
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fill-rule="evenodd">
            <g fill="#7E8B9E">
                <g>
                    <g>
                        <path
                            d="M1.907 4.601C2.852 1.917 5.337 0 8.25 0 11.975 0 15 3.137 15 7s-3.025 7-6.75 7c-2.496 0-4.678-1.408-5.845-3.5-.207-.371-.085-.847.273-1.062.358-.215.817-.088 1.025.283.908 1.628 2.605 2.723 4.547 2.723 2.897 0 5.25-2.44 5.25-5.444 0-3.005-2.353-5.444-5.25-5.444-2.413 0-4.447 1.69-5.06 3.991l1.313-.778c.36-.213.818-.084 1.023.29.206.372.08.847-.279 1.06L2.622 7.676c-.178.106-.39.13-.586.07-.196-.06-.36-.201-.453-.39l-1.5-3.036c-.19-.382-.043-.85.325-1.047.368-.196.82-.044 1.01.338l.49.991zM8.6 6.567l2.166 2.106c.312.303.312.796 0 1.1-.312.303-.82.303-1.131 0l-2.4-2.334C7.083 7.293 7 7.095 7 6.889V3.778c0-.43.358-.778.8-.778.442 0 .8.348.8.778v2.79z"
                            transform="translate(-239 -17) translate(239 17) translate(1)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
`
